<template>
  <!--<div class="side-bar">
    <a :href="QQUrl" class="icon-qq" :title="'QQ: '+ qq">QQ在线咨询</a>
    <a href="#" class="icon-chat" :title="'微信号: '+ wechat">微信
      <div class="chat-tips">
        <i></i>
        <img style="width: 138px;height:138px;" :src="wechatUrl" alt="微信客服">
      </div>
    </a>
   <a :href="'tel:'+ serviceIphone" :title="'客服手机：'+serviceIphone" class="icon-blog">客服手机</a>
  </div>-->
  <div class="suspend">
    <dl>
      <dt class="IE6PNG"></dt>
      <dd class="suspendQQ">
        <a :href="QQUrl" target="_blank">
        </a>
      </dd>
      <dd class="suspendTel">
        <img style="width: 114px;height:128px;" :src="wechatUrl" alt="微信客服">
      </dd>
    </dl>
  </div>
</template>

<script>
import {queryBusinessContactInfo} from "../api/b2cbusiness/b2c_saleman";
import $ from 'jquery'

export default {
  name: "CustomerServiceComponent",
  data() {
    return {
      QQUrl: "http://wpa.qq.com/msgrd?v=3&uin=761770884&site=qq&menu=yes&from=message&isappinstalled=0",
      qq: "",
      wechat: "",
      serviceIphone: "",
      wechatUrl: ""
    }
  },
  mounted() {
    queryBusinessContactInfo().then(res => {
      if (res.success) {
        this.QQUrl = "http://wpa.qq.com/msgrd?v=3&uin=" + res.data.qq + "&site=qq&menu=yes&from=message&isappinstalled=0";
        this.qq = res.data.qq;
        this.wechatUrl = res.data.qrcodeUrl;
        this.wechat = res.data.wechat;
        this.serviceIphone = res.data.telphone;
      }
    });

    $(document).ready(function () {
      $(".suspend").mouseover(function() {
        $(this).stop();
        $(this).animate({width: 160}, 400);
      })

      $(".suspend").mouseout(function() {
        $(this).stop();
        $(this).animate({width: 55}, 400);
      });
    })
  }
}
</script>

<style lang="scss" scoped>
*{margin:0;padding:0;list-style-type:none;}
a,img{border:0;}
body{font:12px/180% Arial, Helvetica, sans-serif, "宋体";}
/* suspend */
.suspend{width:55px;height:258px;position:fixed;top:200px;right:0;overflow:hidden;z-index:9999;}
.suspend dl{width:120px;height:258px;border-radius:25px 0 0 25px;padding-left:55px;}
.suspend dl dt{width:55px;height:258px;background:url(../assets/img/suspend.png);position:absolute;top:0;left:0;cursor:pointer;}
.suspend dl dd.suspendQQ{width:120px;height:110px;background:#ffffff;border-top-left-radius: 30px;}
.suspend dl dd.suspendQQ a{width:120px;height:110px;display:block;background:url(../assets/img/suspend.png) -55px 0px;overflow:hidden;}
.suspend dl dd.suspendTel{width:120px;height:143px;background:#ffffff;border-top:1px solid #e4e8ec;border-bottom-left-radius: 20px;}
.suspend dl dd.suspendTel img{width:106px;height:115px;display:block;overflow:hidden;}
* html .suspend{position:absolute;left:expression(eval(document.documentElement.scrollRight));top:expression(eval(document.documentElement.scrollTop+200))}
/*
.side-bar a, .chat-tips i {
  background-color: #04befe;
}

.side-bar {
  width: 66px;
  position: fixed;
  bottom: 5%;
  right: 1%;
  font-size: 0;
  line-height: 0;
}

.side-bar a {
  width: 66px;
  height: 66px;
  display: inline-block;
  background-color: #ddd;
  margin-bottom: 2px;
}

.side-bar a:hover {
  background-color: #669fdd;
}

.side-bar .icon-qq {
  background-position: 0 -62px;
  background-image: url("../assets/img/vue.config.webp");
  background-size: contain;
  z-index: 100;
}

.side-bar .icon-chat {
  background-position: 0 -130px;
  position: relative;
  background-image: url("../assets/img/wechat.webp");
  background-size: contain;
  z-index: 100;
}

.side-bar .icon-chat:hover .chat-tips {
  display: block;
}

.side-bar .icon-blog {
  background-position: 0 -198px;
  background-image: url("../assets/img/phone.webp");
  background-size: contain;
  z-index: 100;
}

.side-bar .icon-mail {
  background-position: 0 -266px;
}

.side-bar .icon-totop {
  background-position: 0 -334px;
}

.chat-tips {
  padding: 20px;
  border: 1px solid #d1d2d6;
  position: absolute;
  right: 78px;
  top: -55px;
  background-color: #fff;
  display: none;
}

.chat-tips i {
  width: 9px;
  height: 16px;
  display: inline-block;
  position: absolute;
  right: -9px;
  top: 80px;
  background-position: -88px -350px;
}

.chat-tips img {
  width: 138px;
  height: 138px;
}

 */
</style>
